// src/utils/formatters.js

export function formatDate(dateString) {
    if (!dateString) return 'N/A';

    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',

    };
    return new Date(dateString).toLocaleDateString('en-US', options);
}

export function formatCurrency(amount) {
    if (typeof amount !== 'number') return 'N/A';

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES', // Kenyan Shillings (change to your preferred currency)
        minimumFractionDigits: 2
    }).format(amount);
}